//created by sudip
interface PlatformHeaderProps {
    accent: string;
}

export function PlatformHeader({
    accent,
}: PlatformHeaderProps) {

    return (

        <div className="flex items-center justify-between border-b border-slate-100 px-7 pt-6 pb-4">

            <div>

                <p
                    className="text-xs font-semibold uppercase tracking-[0.18em]"
                    style={{
                        color: accent,
                    }}
                >
                    Enterprise AI Platform
                </p>

                <h3 className="mt-2 text-2xl font-bold text-slate-900">

                    Connected Digital Operations

                </h3>

                <p className="mt-2 text-sm text-slate-500">

                    AI • Automation • Cloud • Mobile

                </p>

            </div>

            <div
                className="flex h-16 w-16 items-center justify-center rounded-2xl text-3xl font-bold text-white"
                style={{
                    background: accent,
                }}
            >

                V

            </div>

        </div>

    );

}